import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const PersistedReEnrollAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: getIsInternal() ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.PERSISTED_RE_ENROLL.persistedListInternal_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.PERSISTED_RE_ENROLL.persistedListExternal_jsx',
    elements: {
      ObjectNameLabel,
      ListNameLabel,
      b: 'b'
    },
    options: {
      objectName: {
        portalId: selectedEnrollment.portalId,
        objectTypeId: selectedEnrollment.objectTypeId,
        objectId: selectedEnrollment.objectId,
        showId: getIsInternal()
      },
      listId: diagnosisReason.reEnrollmentList.listId
    }
  });
};
export default PersistedReEnrollAnalysisDetails;